<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">Support Warranty Policy</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Support Warranty Policy</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toSupportWarrantyPolicyCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增 Warranty Policy</span>
      </button>
    </div>
    <!-- Table -->
    <SupportWarrantyPolicyTable></SupportWarrantyPolicyTable>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import SupportWarrantyPolicyTable from '@/views/H-3__SupportWarrantyPolicy/c/SupportWarrantyPolicyTable.vue';

export default {
  components: {
    SupportWarrantyPolicyTable,
  },
  created() {
    this.clear();
    this.getPolicies();
  },
  methods: {
    ...mapActions('supportWarrantyPolicy', {
      getPolicies: 'find',
      clear: 'clear',
    }),
    toSupportWarrantyPolicyCreate() {
      this.$router.push({ path: '/support-warranty-policy/create' });
    },
  },
};
</script>

<style></style>
